import { render, staticRenderFns } from "./crudInstancesSystemDocker.vue?vue&type=template&id=a5637a36&scoped=true&"
import script from "./crudInstancesSystemDocker.vue?vue&type=script&lang=js&"
export * from "./crudInstancesSystemDocker.vue?vue&type=script&lang=js&"
import style0 from "./crudInstancesSystemDocker.vue?vue&type=style&index=0&id=a5637a36&prod&lang=css&"
import style1 from "./crudInstancesSystemDocker.vue?vue&type=style&index=1&id=a5637a36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5637a36",
  null
  
)

export default component.exports